import { authFetch } from '../utils/authFetch';
import {baseUrl} from '../utils/requestUrl'
export  const fetchOutstandingDocuments = async(page = 1, pageSize = 10) => {
    const providerId = JSON.parse(localStorage.getItem('user')).organizations[0].careProvider.id;
    const response = await authFetch(`${baseUrl}/outstandingDocument?pageNumber=${page}&providerId=${providerId}&pageSize=${pageSize}`);
    
    return response.json(); 
}